import { useState, useEffect, useRef } from 'react';

/**
 * Hook that returns true when the target element is about to enter the viewport
 * Used for lazy loading sections
 */
export const useIntersectionLoader = (rootMargin = '200px') => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [rootMargin]);

  return { ref, isVisible };
};
